import querystring from 'querystring';
import { api, Auth } from '../../config/configuration/react';
// Get API Concessions
export default async function getSourcesApi() {
  const sourceIds = Auth.sourceIds().join(',');
  const userRole = Auth.roleId();
  const userCountry = Auth.country();
  let parameters = `filter={"ids":[${sourceIds}], "enabled":true}&range=[0,999]&sort=["label","ASC"]`;
  if ([3].includes(userRole)) {
    parameters = `filter={"country": "${userCountry}", "enabled":true}&range=[0,999]&sort=["label","ASC"]`;
  } else if ([5, 6].includes(userRole)) parameters = `filter={"enabled":true}&range=[0,999]&sort=["label","ASC"]`;
  const response = await api('getSources', null, querystring.parse(parameters));
  return response.data;
}

let currentController = null;
export async function getPaginateSourcesApi(pagination = {}) {
  const sourceIds = Auth.sourceIds().join(',');
  const userRole = Auth.roleId();
  const userCountry = Auth.country();

  let parameters = `filter={"ids":[${sourceIds}], "enabled":true`;

  if ([3].includes(userRole)) {
    parameters = `filter={"country": "${userCountry}", "enabled":true`;
  } else if ([5, 6].includes(userRole)) {
    parameters = `filter={"enabled":true`;
  }

  parameters += pagination?.source?.trim() ? `, "source": "${pagination.source}"}` : `}`;
  parameters = `${parameters}&range=[${pagination?.offset},${pagination?.postsPerPage}]&sort=["name","ASC"]`;

  if (currentController) {
    currentController.abort();
  }

  // Create a new AbortController instance for the new request
  currentController = new AbortController();
  const { signal } = currentController;
  const response = await api('getSources', null, querystring.parse(parameters), null, null, 'json', signal);
  currentController = null;
  return {
    list: response.data,
    total: response.headers['content-range'].split('/')[1],
  };
}
